import PropTypes from 'prop-types'
import React, {useEffect, useRef, useState} from 'react'
import {Scrollbar} from 'react-scrollbars-custom'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import Breadcrumbs from './Breadcrumbs'
import MainMenu from './MainMenu'
import EdekaSlogan from '#components/svg/EdekaSlogan'
import {useNavigationState} from '#hooks/useNavigationState'
import {useCurrentUserRole} from '#hooks/store/useCurrentUserRole'
import {useCurrentUserId} from '#hooks/store/useCurrentUserId'
import useUserModuleSettings from '#hooks/useUserModuleSettings'
import useOutsideClick from '#hooks/useOutsideClick'
import AusbildungsplanSubmenu from './Ausbildungsplan/AusbildungsplanSubmenu'

export function RootNavigation({mobileMenuOpen}) {
  const {firstPart, pathParts, isRoot, pathname, contextualUserId} = useNavigationState()
  const {showModule} = useUserModuleSettings()
  const {role} = useCurrentUserRole()
  const {currentUserId} = useCurrentUserId()
  const scrollbar = useRef(null)
  const [pathLength, setPathLength] = useState(pathParts.length)
  const navigationRef = useRef(null)
  useOutsideClick(navigationRef, actions.mobileMenu.closeMenu, mobileMenuOpen)

  useEffect(() => {
    const urlLevelChanged = pathLength !== pathParts.length
    if (urlLevelChanged) {
      if (scrollbar && scrollbar.current) {
        scrollbar.current.scrollToTop()
      }
      setPathLength(pathParts.length)
    }
  }, [pathname, pathParts.length])
  const ausbildungsplanAvailableForUser = showModule('ausbildungsplan')
  const isAusbildungsplan = firstPart === 'ausbildungsplan' && ausbildungsplanAvailableForUser
  const showMainMenu = isRoot && !isAusbildungsplan
  return (
    <nav id="ml-menu" className={`menu ${!mobileMenuOpen ? 'closed' : ''}`} ref={navigationRef}>
      <Breadcrumbs pathname={pathname} />
      <Scrollbar ref={scrollbar} className="nav__wrap" style={{width: '296px'}} noScrollX={true}>
        <div className={`menu-partial ${isAusbildungsplan ? 'left' : ''}`}>
          <MainMenu role={role} pathname={location.pathname} />
        </div>
        {ausbildungsplanAvailableForUser && (
          <div className={`menu-partial ${!isAusbildungsplan ? 'right' : ''}`}>
            <AusbildungsplanSubmenu
              pathParts={pathParts}
              isAusbildungsplanRootPage={pathParts.length === 1}
              currentUserId={currentUserId}
              contextualUserId={contextualUserId || currentUserId}
            />
          </div>
        )}
      </Scrollbar>
      {showMainMenu && (
        <div className="logoWrapper">
          <EdekaSlogan />
          <div className="edekaLogo" />
        </div>
      )}
    </nav>
  )
}

RootNavigation.propTypes = {
  mobileMenuOpen: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  mobileMenuOpen: state.mobileMenu.open,
})

export default connect(mapStateToProps)(RootNavigation)
